import React from 'react';
import { useIntl } from 'react-intl';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import messages from '../../messages';

export const MobileToolsFooter = ({ language }) => {
  const intl = useIntl();
  return (
    <ul className="mobile-tools">
      {language === 'de' && (
        <>
          <li>
            <UniversalLink href="/de/leichte-sprache">
              {intl.formatMessage(messages.leichteSprache)}
            </UniversalLink>
          </li>
          <li>
            <UniversalLink href="/de/barrierefreiheit/angebote-in-gebaerdensprache">
              {intl.formatMessage(messages.gebaerdensprache)}
            </UniversalLink>
          </li>
        </>
      )}
      <li>
        <LanguageSelector fullLabel={true} />
      </li>
    </ul>
  );
};
